module.exports = __webpack_public_path__ + "img/291.190cb09d.jpg";